<template>
  <div id="activityBrand">
    <div class="brand_list">
      <div class="brand_item"
           v-for="(item, index) in brandList"
           :key="index"
           @click="showAlert(item)">
        <img :src="item.logoImage?item.logoImage:defaultImg"
             alt="">
        <div>{{item.storeName}}</div>
        <!--<p class="need_attention"-->
           <!--v-if="!item.whetherCollect">+关注</p>-->
        <!--<p class="is_attention"-->
           <!--v-else>已关注</p>-->
      </div>
    </div>
    <div v-if="isShowAlert"
         class="alert_back"
         @click="closeAlert()"></div>
    <div v-if="isShowAlert"
         class="alert_view">
      <img class="brand_back"
           :src="storeDetail.bannerImage?storeDetail.bannerImage:defaultImg"
           alt="">
      <img class="brand_qrcode"
           :src="storeDetail.qrCode?storeDetail.qrCode:defaultImg"
           alt="">
      <span>长按识别小程序码</span>
      <h5>{{storeDetail.storeName}}</h5>
      <p>进入微商场查看更多品牌介绍与商品，收藏关注不迷路哦~</p>
    </div>
    <img v-if="isShowAlert"
         class="close_icon"
         :src="closeIcon"
         alt=""
         @click="closeAlert()">
  </div>
</template>

<script>
export default {
  name: 'activityBrand',
  data () {
    return {
      closeIcon: this.$store.state.ossLink + 'icon_close.png',
      isShowAlert: false,
      defaultImg: 'https://xym-wechat.oss-cn-hangzhou.aliyuncs.com/cimen/share.png',
      brandList: [],
      storeDetail: {}
    }
  },
  methods: {
    showAlert (item) {
      this.storeDetail = item
      this.isShowAlert = true
    },
    closeAlert () {
      this.isShowAlert = false
    },
    /**
     * /wechat/member/auth/activity/store
     * 获取店铺列表
     */
    getBrandList () {
      let self = this
      self.$fly
        .request({
          url: '/wechat/member/auth/activity/store',
          params: {
            activityId: localStorage.getItem('activityId')
          }
        })
        .then(res => {
          if (res.success) {
            self.brandList = res.data
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    wxShare () {
      let self = this
      self.$fly
        .request({
          url: '/component/wechat/login/get/js/config/stat',
          params: {
            url: location.href.split('#')[0]
          }
        })
        .then(res => {
          if (res.success) {
            self.$wx.config({
              debug: false,
              appId: res.data.appId,
              timestamp: res.data.timestamp,
              nonceStr: res.data.nonceStr,
              signature: res.data.signature,
              jsApiList: [
                'hideAllNonBaseMenuItem',
                'showAllNonBaseMenuItem'
              ]
            })
            self.$wx.ready(function () {
              // 隐藏分享
              self.$wx.hideAllNonBaseMenuItem()
            })
          }
        })
        .catch(err => {
          console.log(err)
        })
    }
  },
  activated () {
    this.isShowAlert = false
    this.getBrandList()
    this.wxShare()
  },
  mounted () { }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
#activityBrand {
  width: 100%;
  background: #fff;
}
.brand_item {
  width: 100%;
  height: 160px;
  position: relative;
  img {
    position: absolute;
    left: 20px;
    top: 27px;
    height: 106px;
    width: 106px;
  }
  div {
    position: absolute;
    top: 0;
    height: 160px;
    line-height: 160px;
    left: 164px;
    font-size: 28px;
    color: #333333;
  }
  p {
    position: absolute;
    right: 20px;
    top: 52px;
    line-height: 56px;
    text-align: center;
    width: 120px;
    height: 56px;
    border-radius: 10px;
    border: solid 1px #ff000c; /* no */
  }
  .need_attention {
    border: solid 1px #ff000c; /* no */
    color: #ff000c;
  }
  .is_attention {
    border: solid 1px #999999; /* no */
    color: #666666;
  }
}
.alert_back {
  position: fixed;
  top: 0;
  left: 0;
  background-color: #000000;
  opacity: 0.5;
  width: 100%;
  height: 100vh;
}
.alert_view {
  position: fixed;
  top: 100px;
  left: 95px;
  width: calc(100% - 190px);
  height: 700px;
  background: #fff;
  .brand_back {
    position: absolute;
    left: 0;
    width: 100%;
    height: 450px;
  }
  .brand_qrcode {
    position: absolute;
    left: 30px;
    bottom: 60px;
    width: 136px;
    height: 136px;
  }
  span {
    position: absolute;
    left: 30px;
    bottom: 30px;
    line-height: 20px;
    font-size: 20px;
    color: #333333;
  }
  h5 {
    left: 200px;
    top: 517px;
    position: absolute;
    font-size: 36px;
    color: #000000;
    line-height: 34px;
  }
  p {
    top: 575px;
    left: 200px;
    position: absolute;
    font-size: 26px;
    color: #333333;
    max-width: 320px;
  }
}
.close_icon {
  position: fixed;
  top: 938px;
  width: 66px;
  height: 66px;
  left: calc(50% - 33px);
}
</style>



// WEBPACK FOOTER //
// src/views/activity/brand.vue